import { createFileRoute } from '@tanstack/react-router';
import { ChecklistsPage } from '@/features/checklists/pages/checklists-page';

export const Route = createFileRoute('/_app/checklists/')({ component: ChecklistsPage });
